import { render, staticRenderFns } from "./end-contract-dialog.vue?vue&type=template&id=af34b490"
import script from "./end-contract-dialog.vue?vue&type=script&lang=js"
export * from "./end-contract-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af34b490')) {
      api.createRecord('af34b490', component.options)
    } else {
      api.reload('af34b490', component.options)
    }
    module.hot.accept("./end-contract-dialog.vue?vue&type=template&id=af34b490", function () {
      api.rerender('af34b490', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/staying/components/end-contract-dialog.vue"
export default component.exports